import { Button } from "antd";
import type { DsmScopeItem } from "design-scope";
import { ScopeBadge, ScopeContextTooltip } from "./scope-context";

/** Bid-package-log cell: scope count (with hover preview) + a "View scope" action. */
export function BidScopeCell({
  items,
  onView
}: {
  items: DsmScopeItem[];
  onView: () => void;
}) {
  if (!items.length) return null;
  return (
    <span className="inline-flex items-center gap-2">
      <ScopeContextTooltip items={items}>
        <span>
          <ScopeBadge count={items.length} />
        </span>
      </ScopeContextTooltip>
      <Button size="small" data-testid="bid-view-scope" onClick={onView}>
        View scope
      </Button>
    </span>
  );
}
